export default __webpack_public_path__ + "static/media/mitBanner.9d1ca8cf.jpg";